import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { RootState } from '../store';

export interface DisputeState {
  fromDate?: string;
  toDate?: string;
  search?: string;
  customerType?: string | string[];
  status?: string | string[];
  page: number;
  limit?: number;
}

const initialState: DisputeState = {
  fromDate: '',
  toDate: '',
  search: '',
  customerType: '',
  status: [],
  page: 0,
  limit: 10,
};

export const disputeSlice = createSlice({
  name: 'dispute',
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<DisputeState>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const { setFilters } = disputeSlice.actions;

export const useDispute = () =>
  useSelector((state: RootState) => state.dispute);

export default disputeSlice.reducer;
